module.exports = __webpack_public_path__ + "static/media/logo-white.c52c8dfe.png";